import Ui1 from './ui1';
import $ from 'jquery';

class Ui {
  constructor(props){
    const { wrapper, ...params } = props;
    this.wrapper = wrapper;
    this.params = {
      ...params
    };

    this._init();
  }

  _init(){
    const { theme } = this.params;
    switch (theme) {
      case 1:
        this._createUi1();
        break;
      default:
        break;
    }
  }

  _createUi1(){
    const { data } = this.params;
    this.Ui = new Ui1({
      data,
      wrapper: this.wrapper,
    })
  }

  detailsShow(){
    this.Ui.detailsShow();
  }

  detailsHide(){
    this.Ui.detailsHide();
  }

  setBtnBg(domId,boolean){
    this.Ui.setBtnBg(domId,boolean);
  }

  setBtnHtml(){
    this.Ui.setHtml();
  }


}

export default Ui;